export default {
      id: "refresh-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "icons.HITByrwA.svg#refresh-usage",
      toString: function () {
        return this.url;
      }
    }